@if (!viewBox && !attribute) {
  <svg
    [attr.class]="classes"
    [attr.width]="width"
    [attr.height]="height || width"
  >
    @if (title && src) {
      <title [attr.id]="src.split('#')[1] + '-title'">
        {{ title }}
      </title>
    }
    <use [attr.xlink:href]="src"></use>
  </svg>
}

@if (!viewBox && attribute) {
  <svg
    [attr.class]="classes"
    [attr.width]="width"
    [attr.height]="height || width"
    svgIconSpriteAttr
    [attribute]="attribute"
  >
    @if (title && src) {
      <title [attr.id]="src.split('#')[1] + '-title'">
        {{ title }}
      </title>
    }
    <use [attr.xlink:href]="src"></use>
  </svg>
}

@if (viewBox && !attribute) {
  <svg
    [attr.class]="classes"
    [attr.width]="width"
    [attr.height]="height || width"
    [attr.viewBox]="viewBox"
    [attr.preserveAspectRatio]="preserveAspectRatio"
  >
    @if (title && src) {
      <title [attr.id]="src.split('#')[1] + '-title'">
        {{ title }}
      </title>
    }
    <use [attr.xlink:href]="src"></use>
  </svg>
}

@if (viewBox && attribute) {
  <svg
    [attr.class]="classes"
    [attr.width]="width"
    [attr.height]="height || width"
    [attr.viewBox]="viewBox"
    [attr.preserveAspectRatio]="preserveAspectRatio"
    svgIconSpriteAttr
    [attribute]="attribute"
  >
    @if (title && src) {
      <title [attr.id]="src.split('#')[1] + '-title'">
        {{ title }}
      </title>
    }
    <use [attr.xlink:href]="src"></use>
  </svg>
}
